/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 * Регенерируется из src/funnels/experiments/web_*.ts: `npm run generate-experiments-registry`.
 * Добавить эксперимент = создать src/funnels/experiments/web_<name>.ts с нужными appArea-ключами.
 * Удалить = git rm этого файла. Реестр подтянется автоматически (вшит в prebuild/lint/prepare).
 */
import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_autotest_female_funnel_check from './experiments/web_autotest_female_funnel_check'
import web_br_pricing_unification from './experiments/web_br_pricing_unification'
import web_compliance_jul_2026 from './experiments/web_compliance_jul_2026'
import web_compliance_jun_2026 from './experiments/web_compliance_jun_2026'
import web_day_1_session_reveal from './experiments/web_day_1_session_reveal'
import web_eu_pricing_unification_g1 from './experiments/web_eu_pricing_unification_g1'
import web_eu_pricing_unification_g2 from './experiments/web_eu_pricing_unification_g2'
import web_f_walking_age_imagery from './experiments/web_f_walking_age_imagery'
import web_f_walking_senior_discount_popup from './experiments/web_f_walking_senior_discount_popup'
import web_fasting_postmenopausal from './experiments/web_fasting_postmenopausal'
import web_female_water_fasting_japanese from './experiments/web_female_water_fasting_japanese'
import web_lymph_walk_f_paywall_ba_legs from './experiments/web_lymph_walk_f_paywall_ba_legs'
import web_m_chair_fitness_age from './experiments/web_m_chair_fitness_age'
import web_main_16_8_fasting from './experiments/web_main_16_8_fasting'
import web_main_article_longread from './experiments/web_main_article_longread'
import web_main_water_fasting_japanese from './experiments/web_main_water_fasting_japanese'
import web_main_younger_age_groups from './experiments/web_main_younger_age_groups'
import web_male_chair_tai_chi_academy from './experiments/web_male_chair_tai_chi_academy'
import web_male_chair_tai_chi_glucose from './experiments/web_male_chair_tai_chi_glucose'
import web_male_chair_tai_chi_military from './experiments/web_male_chair_tai_chi_military'
import web_male_chair_tai_chi_seated from './experiments/web_male_chair_tai_chi_seated'
import web_mil_calisthenics_m_new_upsell from './experiments/web_mil_calisthenics_m_new_upsell'
import web_mil_calisthenics_m_tai_chi_prices from './experiments/web_mil_calisthenics_m_tai_chi_prices'
import web_military_calisthenics_combat_readiness_score from './experiments/web_military_calisthenics_combat_readiness_score'
import web_military_calisthenics_loader_teaser from './experiments/web_military_calisthenics_loader_teaser'
import web_ml_cr_scoring_3_level_i4_1 from './experiments/web_ml_cr_scoring_3_level_i4_1'
import web_ml_price_prediction from './experiments/web_ml_price_prediction'
import web_ml_price_prediction_high_wtp_i2_2 from './experiments/web_ml_price_prediction_high_wtp_i2_2'
import web_ml_price_prediction_wtp_traffic_source_i3_1 from './experiments/web_ml_price_prediction_wtp_traffic_source_i3_1'
import web_need_matched_personalization from './experiments/web_need_matched_personalization'
import web_paywall_price_anchor from './experiments/web_paywall_price_anchor'
import web_paywall_with_social_proof from './experiments/web_paywall_with_social_proof'
import web_pix_payment_method_for_br from './experiments/web_pix_payment_method_for_br'
import web_planpicker_save_w_checkout_update from './experiments/web_planpicker_save_w_checkout_update'
import web_pricing_au_dk_se_ch from './experiments/web_pricing_au_dk_se_ch'
import web_redirect_simple_moves from './experiments/web_redirect_simple_moves'
import web_refactor_result_complete from './experiments/web_refactor_result_complete'
import web_relaxed_upsells from './experiments/web_relaxed_upsells'
import web_remove_1_week_from_plans from './experiments/web_remove_1_week_from_plans'
import web_reprice_upsells_nonus from './experiments/web_reprice_upsells_nonus'
import web_show_2_plans from './experiments/web_show_2_plans'
import web_spots_left from './experiments/web_spots_left'
import web_sunday_offer_landing from './experiments/web_sunday_offer_landing'
import web_sunday_offer_paywall from './experiments/web_sunday_offer_paywall'
import web_tai_chi_al_paywall_plan_benefits from './experiments/web_tai_chi_al_paywall_plan_benefits'
import web_tai_chi_al_risk_free_offer from './experiments/web_tai_chi_al_risk_free_offer'
import web_tai_chi_female_v2_moto_block from './experiments/web_tai_chi_female_v2_moto_block'
import web_tai_chi_male_checkout_update from './experiments/web_tai_chi_male_checkout_update'
import web_tai_chi_microdrama_story from './experiments/web_tai_chi_microdrama_story'
import web_tai_chi_walking_adapted_first_screen_by_utm from './experiments/web_tai_chi_walking_adapted_first_screen_by_utm'
import web_tai_chi_walking_f_btn_color from './experiments/web_tai_chi_walking_f_btn_color'
import web_tai_chi_walking_fem_v2_adapted_copy_for_seniors from './experiments/web_tai_chi_walking_fem_v2_adapted_copy_for_seniors'
import web_tai_chi_walking_gs_welcome_topic from './experiments/web_tai_chi_walking_gs_welcome_topic'
import web_tai_chi_walking_walk_at_loader from './experiments/web_tai_chi_walking_walk_at_loader'
import web_tai_chi_yoga_m_glucose from './experiments/web_tai_chi_yoga_m_glucose'
import web_tai_chi_yoga_male_scratch_card from './experiments/web_tai_chi_yoga_male_scratch_card'
import web_transactions_with_auto_refund from './experiments/web_transactions_with_auto_refund'
import web_unify_upsell_second_screen from './experiments/web_unify_upsell_second_screen'
import web_upsells_on_tai_chi from './experiments/web_upsells_on_tai_chi'
import web_walking_gs_indoor_intent from './experiments/web_walking_gs_indoor_intent'
import web_walking_gs_welcome_topic from './experiments/web_walking_gs_welcome_topic'
import web_walking_male_bulk_change from './experiments/web_walking_male_bulk_change'
import web_water_fasting_pr_guide from './experiments/web_water_fasting_pr_guide'
import web_welcome_for_applovin_tai_chi_walking from './experiments/web_welcome_for_applovin_tai_chi_walking'
import web_yoga_f_tai_chi_prices from './experiments/web_yoga_f_tai_chi_prices'
import web_yoga_female_scratch_card_before_the_paywall from './experiments/web_yoga_female_scratch_card_before_the_paywall'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	// Fasting
	'female': {
		web_autotest_female_funnel_check,
		web_br_pricing_unification,
		web_compliance_jul_2026,
		web_eu_pricing_unification_g1,
		web_f_walking_senior_discount_popup,
		web_fasting_postmenopausal,
		web_ml_price_prediction_high_wtp_i2_2,
		web_ml_price_prediction_wtp_traffic_source_i3_1,
		web_paywall_price_anchor,
		web_pricing_au_dk_se_ch,
		web_relaxed_upsells,
		web_reprice_upsells_nonus,
		web_sunday_offer_paywall,
		web_unify_upsell_second_screen,
	},
	'male': {
		web_compliance_jun_2026,
		web_f_walking_senior_discount_popup,
		web_ml_price_prediction_wtp_traffic_source_i3_1,
		web_relaxed_upsells,
		web_sunday_offer_paywall,
		web_unify_upsell_second_screen,
	},
	'main': {
		web_main_16_8_fasting,
		web_main_article_longread,
		web_main_younger_age_groups,
		web_sunday_offer_landing,
	},
	'female-water-fasting': {
		web_eu_pricing_unification_g1,
		web_f_walking_senior_discount_popup,
		web_female_water_fasting_japanese,
		web_ml_price_prediction_wtp_traffic_source_i3_1,
		web_paywall_price_anchor,
		web_pricing_au_dk_se_ch,
		web_reprice_upsells_nonus,
		web_unify_upsell_second_screen,
		web_water_fasting_pr_guide,
	},
	'male-water-fasting': {},
	'main-water-fasting': {
		web_main_water_fasting_japanese,
		web_sunday_offer_landing,
	},
	'female-pr': {},
	'male-pr': {},
	'main-pr': {},

	// Yoga
	'activity-female-yoga': {
		web_compliance_jun_2026,
		web_relaxed_upsells,
		web_yoga_f_tai_chi_prices,
		web_yoga_female_scratch_card_before_the_paywall,
	},
	'activity-male-chair-workouts': {
		web_compliance_jun_2026,
		web_m_chair_fitness_age,
		web_paywall_with_social_proof,
		web_relaxed_upsells,
	},
	'main-yoga': {},

	// Walking
	'activity-female-walking': {
		web_br_pricing_unification,
		web_compliance_jul_2026,
		web_eu_pricing_unification_g1,
		web_f_walking_age_imagery,
		web_ml_cr_scoring_3_level_i4_1,
		web_ml_price_prediction,
		web_ml_price_prediction_wtp_traffic_source_i3_1,
		web_planpicker_save_w_checkout_update,
		web_pricing_au_dk_se_ch,
		web_redirect_simple_moves,
		web_relaxed_upsells,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_unify_upsell_second_screen,
		web_upsells_on_tai_chi,
	},
	'activity-female-walking-outdoor': {
		web_redirect_simple_moves,
	},
	'activity-female-lymphatic-walking': {
		web_lymph_walk_f_paywall_ba_legs,
	},
	'activity-female-lymphatic-walking-pr': {
		web_lymph_walk_f_paywall_ba_legs,
	},
	'activity-female-nordic-walking-fwf': {},
	'activity-male-walking': {
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_relaxed_upsells,
		web_sunday_offer_paywall,
		web_unify_upsell_second_screen,
		web_upsells_on_tai_chi,
		web_walking_male_bulk_change,
	},
	'female-printable-walking': {},
	'activity-female-walking-japanese': {},
	'main-walking': {
		web_walking_gs_indoor_intent,
		web_walking_gs_welcome_topic,
	},
	'main-lymphatic-walking': {},
	'main-walking-outdoor': {},
	'main-lymphatic-walking-pr': {},

	// Pilates
	'activity-female-pilates': {},

	// Activity
	'activity-female-v2': {},
	'activity-male': {},
	'main-activity': {},

	// Tai Chi
	'activity-female-tai-chi': {},
	'activity-female-tai-chi-walking-v2': {
		web_br_pricing_unification,
		web_compliance_jul_2026,
		web_day_1_session_reveal,
		web_eu_pricing_unification_g2,
		web_ml_cr_scoring_3_level_i4_1,
		web_ml_price_prediction,
		web_need_matched_personalization,
		web_pix_payment_method_for_br,
		web_planpicker_save_w_checkout_update,
		web_pricing_au_dk_se_ch,
		web_relaxed_upsells,
		web_remove_1_week_from_plans,
		web_reprice_upsells_nonus,
		web_show_2_plans,
		web_spots_left,
		web_sunday_offer_paywall,
		web_tai_chi_female_v2_moto_block,
		web_tai_chi_microdrama_story,
		web_tai_chi_walking_adapted_first_screen_by_utm,
		web_tai_chi_walking_f_btn_color,
		web_tai_chi_walking_fem_v2_adapted_copy_for_seniors,
		web_unify_upsell_second_screen,
		web_upsells_on_tai_chi,
	},
	'activity-female-tai-chi-walking-pr': {
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_day_1_session_reveal,
		web_eu_pricing_unification_g2,
		web_f_walking_senior_discount_popup,
		web_ml_cr_scoring_3_level_i4_1,
		web_ml_price_prediction,
		web_paywall_price_anchor,
		web_pix_payment_method_for_br,
		web_redirect_simple_moves,
		web_refactor_result_complete,
		web_relaxed_upsells,
		web_remove_1_week_from_plans,
		web_show_2_plans,
		web_tai_chi_walking_f_btn_color,
		web_unify_upsell_second_screen,
		web_upsells_on_tai_chi,
	},
	'activity-female-chair-tai-chi-fwf': {},
	'activity-male-tai-chi-walking': {},
	'activity-male-tai-chi-yoga': {
		web_compliance_jun_2026,
		web_f_walking_senior_discount_popup,
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_male_scratch_card,
		web_upsells_on_tai_chi,
	},
	'activity-male-tai-chi-yoga-pr': {
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_f_walking_senior_discount_popup,
		web_pix_payment_method_for_br,
		web_redirect_simple_moves,
		web_relaxed_upsells,
		web_tai_chi_male_checkout_update,
		web_tai_chi_yoga_m_glucose,
		web_tai_chi_yoga_male_scratch_card,
		web_transactions_with_auto_refund,
		web_unify_upsell_second_screen,
		web_upsells_on_tai_chi,
	},
	'main-tai-chi': {},
	'main-tai-chi-pr': {},
	'main-tai-chi-walking': {
		web_sunday_offer_landing,
		web_tai_chi_walking_adapted_first_screen_by_utm,
		web_tai_chi_walking_gs_welcome_topic,
		web_tai_chi_walking_walk_at_loader,
	},
	'main-tai-chi-walking-pr': {},
	'activity-male-chair-tai-chi': {
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_eu_pricing_unification_g1,
		web_f_walking_senior_discount_popup,
		web_male_chair_tai_chi_academy,
		web_male_chair_tai_chi_glucose,
		web_male_chair_tai_chi_military,
		web_male_chair_tai_chi_seated,
		web_paywall_price_anchor,
		web_pricing_au_dk_se_ch,
		web_redirect_simple_moves,
		web_relaxed_upsells,
		web_sunday_offer_landing,
		web_tai_chi_microdrama_story,
	},
	'tai-chi-male-golfers-fwf': {},
	'main-chair-tai-chi-pr': {
		web_sunday_offer_landing,
	},

	// Calisthenics
	'activity-female-calisthenics': {},
	'activity-male-calisthenics': {},
	'main-calisthenics': {},
	'military-male': {},
	'activity-male-military-calisthenics': {
		web_compliance_jun_2026,
		web_mil_calisthenics_m_new_upsell,
		web_mil_calisthenics_m_tai_chi_prices,
		web_military_calisthenics_combat_readiness_score,
		web_military_calisthenics_loader_teaser,
	},
	'activity-male-military-calisthenics-pr': {},
	'activity-male-military-calisthenics-sh': {},
	'activity-female-military-calisthenics': {
		web_military_calisthenics_combat_readiness_score,
		web_military_calisthenics_loader_teaser,
		web_redirect_simple_moves,
	},
	'activity-female-military-calisthenics-pr': {},
	'main-military-calisthenics': {},
	'main-military-calisthenics-pr': {},

	// Diets
	'female-mediterranean-diet': {},
	'female-anti-inflammatory-diet': {},
	'female-hashimoto-diet': {},
	'female-ramadan-fwf': {},
	'carnivore-diet-gs': {},
	'carnivore-diet-male': {},
	'carnivore-diet-female': {},
	'japanese-diet': {},
	'male-japanese-diet': {},
	'female-japanese-diet': {},
	'female-korean-glow-diet': {},

	// AppLovin
	'main-tai-chi-walking-al': {},
	'activity-female-pilates-al': {},
	'activity-female-walking-al': {
		web_sunday_offer_landing,
	},
	'activity-male-tai-chi-yoga-al': {
		web_compliance_jun_2026,
		web_relaxed_upsells,
	},
	'activity-male-tai-chi-walking-al': {
		web_br_pricing_unification,
		web_compliance_jun_2026,
		web_relaxed_upsells,
	},
	'main-al': {},
	'female-al': {},
	'male-al': {},
	'activity-female-tai-chi-walking-v2-al': {
		web_br_pricing_unification,
		web_compliance_jul_2026,
		web_day_1_session_reveal,
		web_eu_pricing_unification_g1,
		web_paywall_price_anchor,
		web_pix_payment_method_for_br,
		web_planpicker_save_w_checkout_update,
		web_refactor_result_complete,
		web_relaxed_upsells,
		web_remove_1_week_from_plans,
		web_reprice_upsells_nonus,
		web_show_2_plans,
		web_tai_chi_al_paywall_plan_benefits,
		web_tai_chi_al_risk_free_offer,
		web_tai_chi_walking_f_btn_color,
		web_unify_upsell_second_screen,
		web_upsells_on_tai_chi,
		web_welcome_for_applovin_tai_chi_walking,
	},
	'female-water-fasting-al': {},
	'activity-male-chair-workouts-al': {},
	'activity-male-chair-tai-chi-al': {
		web_compliance_jun_2026,
		web_f_walking_senior_discount_popup,
		web_ml_price_prediction,
		web_redirect_simple_moves,
		web_relaxed_upsells,
	},
	'activity-female-chair-tai-chi-al-fwf': {},

	// Other
	'assessment': {},
	'together': {},
	'workbooks': {},
}

export default experimentsConfig
